import React, { useState, useRef, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaPlusCircle } from "react-icons/fa";
import { FiMinusCircle } from "react-icons/fi";
import { FaRegCalendarAlt } from "react-icons/fa";
import Menu from "../Menu/Menu";

const BlogLayout3 = () => {
  const generateId = () => {
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
      return crypto.randomUUID();
    }

    return (
      Math.random().toString(36).substring(2, 15) + Date.now().toString(36)
    );
  };

  const [title, setTitle] = useState("");
  // const [startDate] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const fileInputRef = useRef(null);
  const [isSaving, setIsSaving] = useState(false);

  const headingOptions = ["h2", "h3", "h4", "h5", "h6"];

  // ===== SEO META STATE =====
  const [slug, setSlug] = useState("");
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [keywords, setKeywords] = useState("");
  const [coverThumb, setCoverThumb] = useState(null);
  const coverInputRef = useRef(null);

  // Main Section Heading
  const [mainTitle, setMainTitle] = useState("");
  const [mainHeadingLevel, setMainHeadingLevel] = useState("h2");

  // Sections
  const [sections, setSections] = useState([
    {
      id: generateId(),
      title: "",
      headingLevel: "h2",
      blocks: [{ id: generateId(), text: "" }],
      images: [],
    },
  ]);

  // ===== ACTIVE SECTION STATE =====

  // eslint-disable-next-line
  const [activeSectionId, setActiveSectionId] = useState(null);
  const wrapperRef = useRef(null);

  // ===== LOGGING TAGS =====
  useEffect(() => {
    console.log("Main Heading Tag:", mainHeadingLevel);
  }, [mainHeadingLevel]);

  useEffect(() => {
    sections.forEach((section) => {
      console.log(`Section ${section.id} Heading Tag:`, section.headingLevel);
    });
  }, [sections]);

  // ===== CLICK OUTSIDE TO DESELECT =====
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setActiveSectionId(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // ===== HELPERS =====
  const getAllowedSectionHeadings = (currentIndex = null) => {
    if (sections.length === 0) {
      const mainIndex = headingOptions.indexOf(mainHeadingLevel);
      return headingOptions.slice(mainIndex);
    }

    if (currentIndex === null) {
      const lastSection = sections[sections.length - 1];
      const lastIndex = headingOptions.indexOf(lastSection.headingLevel);
      return headingOptions.slice(lastIndex);
    }

    if (currentIndex > 0) {
      const prevSection = sections[currentIndex - 1];
      const prevIndex = headingOptions.indexOf(prevSection.headingLevel);
      return headingOptions.slice(prevIndex);
    }

    const mainIndex = headingOptions.indexOf(mainHeadingLevel);
    return headingOptions.slice(mainIndex);
  };

  // ===== HANDLERS =====
  // const handleFileChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file && file.type === "image/webp") {
  //     setImagePreview(URL.createObjectURL(file));
  //   } else {
  //     alert("Please upload a .webp image.");
  //   }
  // };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.type !== "image/webp") {
      alert("Please upload a .webp image.");
      e.target.value = "";
      return;
    }

    // Create image object to check dimensions
    const img = new Image();
    img.src = URL.createObjectURL(file);

    img.onload = () => {
      const { width, height } = img;
      const area = width * height;

      // Validation for max dimension and pixel area
      if (width > 12000 || height > 12000 || area > 100000000) {
        alert(
          `Image is too large:\n${width} × ${height}\n\n` +
            `Max dimension allowed: 12000\n` +
            `Max area allowed: 100,000,000 pixels`,
        );
        e.target.value = ""; // reset input
        return;
      }

      // Passed validation → set preview
      setImagePreview(URL.createObjectURL(file));
    };
  };
  const addSection = () => {
    const allowed = getAllowedSectionHeadings();

    setSections([
      ...sections,
      {
        id: generateId(),
        title: "",
        headingLevel: allowed[0],
        blocks: [{ id: generateId(), text: "" }],
        image: null,
        images: [],
      },
    ]);
  };

  const removeSection = (id) => {
    if (sections.length > 1) {
      setSections(sections.filter((section) => section.id !== id));
    }
  };

  const updateSection = (id, field, value) => {
    setSections(
      sections.map((s) => (s.id === id ? { ...s, [field]: value } : s)),
    );
  };

  // ===== IMAGE HANDLING =====
  const handleSectionImages = (id, files) => {
    const validFiles = Array.from(files).filter(
      (file) => file.type === "image/webp",
    );
    if (!validFiles.length) {
      alert("Please upload .webp images only.");
      return;
    }

    const urls = validFiles.map((file) => URL.createObjectURL(file));
    setSections(
      sections.map((s) =>
        s.id === id ? { ...s, images: [...s.images, ...urls] } : s,
      ),
    );
  };

  const updateBlock = (sectionId, blockId, value) => {
    setSections(
      sections.map((section) =>
        section.id === sectionId
          ? {
              ...section,
              blocks: section.blocks.map((b) =>
                b.id === blockId ? { ...b, text: value } : b,
              ),
            }
          : section,
      ),
    );
  };

  // ======= SAVE & CANCEL LOGIC =======
  // const handleSave = () => {
  //   const blogData = {
  //     title,
  //     publishDate: startDate,
  //     heroImage: imagePreview,
  //     mainHeading: { text: mainTitle, level: mainHeadingLevel },
  //     content: sections,
  //   };
  //   console.log("Saving Layout 3 Data:", blogData);
  //   alert("Layout 3 saved successfully!");
  // };

  const handleCancel = () => {
    if (window.confirm("Are you sure you want to discard changes?")) {
      window.location.reload();
    }
  };
  //================Handle Save ===========
  // ===== DATE HELPERS =====
  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const formatDateTime = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    const hh = String(d.getHours()).padStart(2, "0");
    const min = String(d.getMinutes()).padStart(2, "0");
    const ss = String(d.getSeconds()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
  };

  const handleSave = async () => {
    if (isSaving) return;
    setIsSaving(true);
    const formData = new FormData();

    // MAIN BLOG FIELDS
    formData.append("mainTitle", title);
    formData.append("date", formatDate(publishDate));
    formData.append("headLine", mainTitle);
    formData.append("tagHead", mainHeadingLevel);
    formData.append("slug", slug);
    formData.append("metaTitle", metaTitle);
    formData.append("metaDes", metaDescription);
    formData.append("keywords", JSON.stringify(keywords.split(",")));
    formData.append("scheduleDate", formatDateTime(scheduleDate));
    formData.append("status", "published");
    formData.append("blogType", "BlogLayout3");

    // MAIN HERO IMAGE
    if (fileInputRef.current?.files[0]) {
      formData.append("mainImage", fileInputRef.current.files[0]);
    }

    // SEO THUMBNAIL
    if (coverInputRef.current?.files[0]) {
      formData.append("thumbnailImg", coverInputRef.current.files[0]);
    }

    // SECTIONS
    const formattedSections = sections.map((sec, index) => ({
      tempId: sec.id,
      title: sec.title,
      tag: sec.headingLevel,
      content: sec.blocks.map((b) => b.text),
      position: index + 1,
    }));

    formData.append("sections", JSON.stringify(formattedSections));

    // SECTION IMAGES — Layout 3 supports multiple files per section
    // Backend only stores one coverImg per section, so we send only files[0]
    sections.forEach((sec) => {
      const fileInput = document.getElementById(`file-${sec.id}`);
      if (fileInput && fileInput.files[0]) {
        formData.append(`coverImg_${sec.id}`, fileInput.files[0]);
      }
    });

    // API CALL
    try {
      const response = await fetch(
        "https://sohamvillas.com/web-backend/blogs",
        {
          method: "POST",
          body: formData,
        },
      );

      const data = await response.json();
      console.log("Backend Response:", data);

      if (data.success) alert("Blog saved!");
      else alert("Failed to save blog");
    } catch (err) {
      console.error("SAVE ERROR:", err);
      alert("Network error");
    } finally {
      setIsSaving(false);
    }
  };
  const handleCoverThumb = (file) => {
    if (file && file.type === "image/webp") {
      setCoverThumb(URL.createObjectURL(file));
    } else {
      alert("Please upload a .webp image.");
    }
  };

  const [scheduleDate, setScheduleDate] = useState(null);
  const [publishDate, setPublishDate] = useState(null);

  return (
    <div>
      <Menu />
      <div className="pt-0 pb-10">
        <div className="lg:ml-[8%] p-[3%] md:p-[2%]">
          <div ref={wrapperRef} className="text-right">
            {/* Main Title */}
            <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
              <div className="flex items-center gap-3">
                <p className="text-sm font-medium whitespace-nowrap">
                  Schedule Post :
                </p>

                <div className="relative w-[130px]">
                  <DatePicker
                    selected={scheduleDate}
                    onChange={(date) => setScheduleDate(date)}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="dd/MM/yyyy"
                    className="w-full border border-gray-300 rounded px-3 py-1 text-sm pr-8 outline-none cursor-pointer"
                  />
                  <FaRegCalendarAlt
                    className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none "
                    size={14}
                  />
                </div>
              </div>
              <div className="flex-1">
                <h1
                  className="title text-xl md:text-3xl 2xl:text-4xl capitalize text-right"
                  style={{ letterSpacing: "2px" }}
                >
                  <textarea
                    type="text"
                    placeholder="Enter Blog Title Here..."
                    value={title}
                    onChange={(e) => {
                      const maxChars = 100;
                      if (e.target.value.length <= maxChars) {
                        setTitle(e.target.value);
                      }
                    }}
                    className="w-full md:w-[90%] resize-none bg-transparent text-right capitalize border-none outline-none placeholder:text-gray-400 py-2"
                  />
                </h1>

                <p className="text-sm text-gray-500 text-right mt-1">
                  {title.length} / 100
                </p>
              </div>
            </div>

            {/* Date */}
            <style>
              {`
              .react-datepicker__day--selected,
              .react-datepicker__day--keyboard-selected {
                background-color: #877D6F !important;
                color: white !important;
              }

              .react-datepicker__day--selected:hover {
                background-color: #877D6F !important;
              }
            `}
            </style>

            <div className="my-4 max-w-60 ml-auto">
              <DatePicker
                selected={publishDate}
                onChange={(date) => setPublishDate(date)}
                dateFormat="dd/MM/yyyy"
                placeholderText="Select Blog Date"
                className="bg-transparent outline-none cursor-pointer text-right"
                popperPlacement="bottom-end"
              />
            </div>

            {/* Hero Image */}
            <div
              onClick={() => {
                if (!imagePreview) fileInputRef.current.click();
              }}
              className="mt-8 w-full h-[280px] sm:h-[350px] md:h-[420px] lg:h-[500px] 
                        border-2 border-dashed border-gray-300 rounded-[40px] 
                        flex items-center justify-center bg-white 
                        cursor-pointer transition relative overflow-hidden"
            >
              {imagePreview ? (
                <>
                  <img
                    src={imagePreview}
                    alt="Hero"
                    className="absolute inset-0 w-full h-full object-cover"
                  />

                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      fileInputRef.current.click();
                    }}
                    className="absolute bottom-4 right-4 
                              flex items-center gap-1
                              bg-white/30 backdrop-blur-md
                              text-[#877D6F] text-sm font-medium 
                              px-4 py-1.5 rounded-full shadow-md 
                              hover:scale-110 transition"
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <rect
                        x="2"
                        y="4"
                        width="16"
                        height="13"
                        rx="2"
                        stroke="#ebeae8"
                        strokeWidth="1.5"
                      />
                      <circle cx="6.5" cy="8.5" r="1.5" fill="#ebeae8" />
                      <path
                        d="M2 13L6 9L11 14L14 11L18 15"
                        stroke="#ebeae8"
                        strokeWidth="1.5"
                      />
                      <circle
                        cx="17"
                        cy="17"
                        r="6"
                        fill="#877D6F"
                        stroke="#ebeae8"
                        strokeWidth="1.5"
                      />
                      <path
                        d="M17 14V20M14 17H20"
                        stroke="#ebeae8"
                        strokeWidth="1.5"
                      />
                    </svg>
                    Replace
                  </button>
                </>
              ) : (
                <div className="flex flex-col items-center text-center px-4">
                  <svg
                    width="120"
                    height="100"
                    viewBox="0 0 24 24"
                    fill="none"
                    className="mb-2"
                  >
                    <rect
                      x="2"
                      y="4"
                      width="16"
                      height="13"
                      rx="2"
                      stroke="black"
                      strokeWidth="1.5"
                    />
                    <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                    <path
                      d="M2 13L6 9L11 14L14 11L18 15"
                      stroke="black"
                      strokeWidth="1.5"
                    />
                    <circle
                      cx="17"
                      cy="17"
                      r="6"
                      fill="white"
                      stroke="black"
                      strokeWidth="1.5"
                    />
                    <path
                      d="M17 14V20M14 17H20"
                      stroke="black"
                      strokeWidth="1.5"
                    />
                  </svg>
                  <p className="text-gray-700 font-medium">
                    Upload Webp image only
                  </p>
                </div>
              )}

              <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                className="hidden"
                accept="image/webp"
              />
            </div>

            {/* Main Section Heading */}
            <div
              className="title capitalize my-10 flex flex-col gap-3"
              style={{ letterSpacing: "2px" }}
            >
              <textarea
                placeholder="Section Heading..."
                value={mainTitle}
                onChange={(e) => setMainTitle(e.target.value)}
                rows={1}
                className="w-full bg-[#FAFAFA] p-2 outline-none resize-none font-bold text-2xl text-left"
              />
              <select
                value={mainHeadingLevel}
                onChange={(e) => setMainHeadingLevel(e.target.value)}
                className="border border-gray-300 rounded px-1 py-1 w-fit text-xs self-start focus:ring-0 focus:outline-none focus:border-black"
              >
                {headingOptions.map((h) => (
                  <option key={h} value={h}>
                    {h.toUpperCase()}
                  </option>
                ))}
              </select>
            </div>

            {/* ===== DYNAMIC SECTIONS ===== */}
            {sections.map((section) => {
              const allowedHeadings = getAllowedSectionHeadings(
                sections.findIndex((s) => s.id === section.id),
              );

              return (
                <div
                  key={section.id}
                  className="relative pb-20"
                  onClick={() => setActiveSectionId(section.id)}
                >
                  <div
                    className="grid lg:grid-cols-2 gap-12 items-start bg-[#FAFAFA] px-5 md:px-12 py-12 
                              border border-transparent 
                              hover:border-gray-400 hover:shadow-sm
                              transition-all duration-200"
                  >
                    {/* ===== LEFT CONTENT ===== */}
                    <div className="text-left">
                      <div className="absolute right-3 top-3 flex gap-1 z-10">
                        <button
                          onClick={addSection}
                          className="hover:scale-110 transition-transform text-[#877D6F]"
                        >
                          <FaPlusCircle size={22} />
                        </button>
                        {sections.length > 1 && (
                          <button
                            onClick={() => removeSection(section.id)}
                            className="hover:scale-110 transition-transform text-[#877D6F]"
                          >
                            <FiMinusCircle size={23} />
                          </button>
                        )}
                      </div>

                      <div className="flex flex-col gap-2 mb-4 lg:-mt-5">
                        <input
                          type="text"
                          placeholder="Add Title..."
                          value={section.title}
                          maxLength={100}
                          onChange={(e) =>
                            updateSection(section.id, "title", e.target.value)
                          }
                          className="w-full bg-transparent border-b outline-none font-semibold text-[14px] md:text-xl lg:text-[16px] 2xl:text-2xl"
                        />

                        <div className="flex items-center justify-between">
                          <select
                            value={section.headingLevel}
                            onChange={(e) =>
                              updateSection(
                                section.id,
                                "headingLevel",
                                e.target.value,
                              )
                            }
                            className="border border-gray-300 rounded px-2 py-1 text-xs focus:ring-0 focus:outline-none focus:border-black"
                          >
                            {allowedHeadings.map((h) => (
                              <option key={h} value={h}>
                                {h.toUpperCase()}
                              </option>
                            ))}
                          </select>

                          <span className="text-xs text-gray-400">
                            {section.title.length}/100
                          </span>
                        </div>
                      </div>

                      {section.blocks.map((block) => (
                        <div key={block.id} className="relative">
                          <textarea
                            placeholder="Start writing..."
                            value={block.text}
                            maxLength={500}
                            onChange={(e) => {
                              updateBlock(section.id, block.id, e.target.value);
                            }}
                            className="w-full bg-transparent outline-none text-gray-600 
                            text-[13px] md:text-[13.7px] lg:text-[13.7px] xl:text-[16px]
                            lg:h-[215px] md:h-[130px] sm:h-[130px] h-[260px] resize-none overflow-hidden p-1
                            border border-transparent 
                            hover:border-gray-400 
                            transition-all duration-200"
                          />

                          <p className="text-xs text-gray-400 text-left">
                            {block.text.length} / 500
                          </p>
                        </div>
                      ))}
                    </div>

                    {/* ===== RIGHT IMAGE COLUMN ===== */}
                    <div className="flex flex-col gap-6 relative min-h-[300px]">
                      <div className="grid grid-cols-1 gap-4">
                        {section.images.map((img, imgIndex) => (
                          <div key={imgIndex} className="relative group">
                            <img
                              src={img}
                              alt="Section"
                              className="w-full h-72 rounded-xl object-cover shadow-sm border border-gray-200"
                            />
                          </div>
                        ))}

                        {section.images.length === 0 && (
                          <div className="flex flex-col items-center justify-center w-full h-72 border-2 border-dashed border-gray-300 rounded-2xl bg-white">
                            <label
                              htmlFor={`file-${section.id}`}
                              className="flex flex-col items-center justify-center gap-2 cursor-pointer"
                            >
                              <svg
                                width="60"
                                height="50"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <rect
                                  x="2"
                                  y="4"
                                  width="16"
                                  height="13"
                                  rx="2"
                                  stroke="black"
                                  strokeWidth="1.5"
                                />
                                <circle
                                  cx="6.5"
                                  cy="8.5"
                                  r="1.5"
                                  fill="black"
                                />
                                <path
                                  d="M2 13L6 9L11 14L14 11L18 15"
                                  stroke="black"
                                  strokeWidth="1.5"
                                />
                                <circle
                                  cx="17"
                                  cy="17"
                                  r="6"
                                  fill="white"
                                  stroke="black"
                                  strokeWidth="1.5"
                                />
                                <path
                                  d="M17 14V20M14 17H20"
                                  stroke="black"
                                  strokeWidth="1.5"
                                />
                              </svg>

                              <span className="text-sm font-semibold">
                                Add only Webp
                              </span>
                            </label>
                          </div>
                        )}
                      </div>

                      <div className="absolute bottom-0 right-0">
                        <input
                          type="file"
                          id={`file-${section.id}`}
                          className="hidden"
                          accept="image/webp"
                          multiple
                          onChange={(e) =>
                            handleSectionImages(section.id, e.target.files)
                          }
                        />

                        <label
                          htmlFor={`file-${section.id}`}
                          className="flex items-center gap-2 cursor-pointer border border-gray-300 -mb-8 px-4 py-1 rounded-lg shadow-sm hover:bg-gray-50 transition-all"
                        >
                          <svg
                            width="21"
                            height="21"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <rect
                              x="2"
                              y="4"
                              width="16"
                              height="13"
                              rx="2"
                              stroke="black"
                              strokeWidth="1.5"
                            />
                            <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                            <path
                              d="M2 13L6 9L11 14L14 11L18 15"
                              stroke="black"
                              strokeWidth="1.5"
                            />
                            <circle
                              cx="17"
                              cy="17"
                              r="6"
                              fill="white"
                              stroke="black"
                              strokeWidth="1.5"
                            />
                            <path
                              d="M17 14V20M14 17H20"
                              stroke="black"
                              strokeWidth="1.5"
                            />
                          </svg>

                          <span className="text-sm font-semibold">
                            {section.images.length > 0 ? "Replace" : "Add"}
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}

            {/* ================= META SECTION ============== */}
            <div className="border-t border-gray-400 pt-12">
              <h3 className="text-lg font-semibold mb-6 text-left tracking-wide">
                Meta data
              </h3>

              <div className="grid grid-cols-1 lg:grid-cols-[1fr_450px] gap-10 items-start">
                <div className="flex flex-col gap-5 text-left">
                  <input
                    type="text"
                    placeholder="Slug" //(example: best-ai-tools-2025)
                    value={slug}
                    onChange={(e) => setSlug(e.target.value)}
                    className="w-full bg-transparent border border-gray-300 rounded-md px-3 py-2 outline-none"
                  />

                  <input
                    type="text"
                    placeholder="Meta Title"
                    value={metaTitle}
                    onChange={(e) => setMetaTitle(e.target.value)}
                    className="w-full bg-transparent border border-gray-300 rounded-md px-3 py-2 outline-none"
                  />

                  <textarea
                    placeholder="Meta Description"
                    value={metaDescription}
                    onChange={(e) => setMetaDescription(e.target.value)}
                    rows={3}
                    className="w-full bg-transparent border border-gray-300 rounded-md px-3 py-2 outline-none resize-none"
                  />

                  <input
                    type="text"
                    placeholder="Keywords"
                    value={keywords}
                    onChange={(e) => setKeywords(e.target.value)}
                    className="w-full bg-transparent border border-gray-300 rounded-md px-3 py-2 outline-none"
                  />
                </div>

                <div className="w-full flex flex-col">
                  <input
                    ref={coverInputRef}
                    type="file"
                    id="cover-upload"
                    className="hidden"
                    accept="image/webp"
                    onChange={(e) => handleCoverThumb(e.target.files[0])}
                  />

                  <div
                    onClick={() => coverInputRef.current.click()}
                    className="w-full h-[300px] border-2 border-dashed border-gray-300 rounded-xl flex items-center justify-center bg-white cursor-pointer transition relative overflow-hidden"
                  >
                    {coverThumb ? (
                      <img
                        src={coverThumb}
                        alt="Cover Thumbnail"
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="flex flex-col items-center text-center px-4">
                        <svg
                          width="50"
                          height="50"
                          viewBox="0 0 24 24"
                          fill="none"
                          className="mb-2"
                        >
                          <rect
                            x="2"
                            y="4"
                            width="16"
                            height="13"
                            rx="2"
                            stroke="black"
                            strokeWidth="1.5"
                          />
                          <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                          <path
                            d="M2 13L6 9L11 14L14 11L18 15"
                            stroke="black"
                            strokeWidth="1.5"
                          />
                          <circle
                            cx="17"
                            cy="17"
                            r="6"
                            fill="white"
                            stroke="black"
                            strokeWidth="1.5"
                          />
                          <path
                            d="M17 14V20M14 17H20"
                            stroke="black"
                            strokeWidth="1.5"
                          />
                        </svg>
                        <p className="text-gray-600 text-sm font-medium">
                          Upload Cover Thumbnail (webp)
                        </p>
                      </div>
                    )}
                  </div>

                  <div className="flex justify-end mt-3">
                    <button
                      type="button"
                      onClick={() => coverInputRef.current.click()}
                      className="flex items-center gap-2 border border-gray-300 px-4 py-1 rounded-lg shadow-sm hover:bg-gray-50 transition-all"
                    >
                      <svg
                        width="21"
                        height="21"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          x="2"
                          y="4"
                          width="16"
                          height="13"
                          rx="2"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                        <path
                          d="M2 13L6 9L11 14L14 11L18 15"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle
                          cx="17"
                          cy="17"
                          r="6"
                          fill="white"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M17 14V20M14 17H20"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                      </svg>

                      <span className="text-sm font-semibold">
                        {coverThumb ? "Replace" : "Add"}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* ===== SAVE & CANCEL BUTTONS ===== */}
            <div className="mt-0 flex justify-end gap-1 pt-10">
              <button onClick={handleCancel} className="cancel_btn">
                Cancel
              </button>
              {/* <button onClick={handleSave} className="done_btn">
                Save
              </button> */}
              <button
                onClick={handleSave}
                disabled={isSaving}
                className={`done_btn flex items-center gap-2 ${isSaving ? "opacity-60 cursor-not-allowed" : ""}`}
              >
                {isSaving ? (
                  <>
                    <svg
                      className="animate-spin h-4 w-4 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      />
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v8z"
                      />
                    </svg>
                    Saving...
                  </>
                ) : (
                  "Save"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default BlogLayout3;
